import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=da260a16&"
import script from "./CreateModal.vue?vue&type=script&lang=js&"
export * from "./CreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da260a16')) {
      api.createRecord('da260a16', component.options)
    } else {
      api.reload('da260a16', component.options)
    }
    module.hot.accept("./CreateModal.vue?vue&type=template&id=da260a16&", function () {
      api.rerender('da260a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/pool/CreateModal.vue"
export default component.exports